import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, VStack, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from '../components/primitives/buttons/SecondaryButton';
import { ReviewCard, ReviewCardProps } from '../components/reviews/ReviewCard';

interface Props {
  reviews: ReviewCardProps[];
}

export function ReviewsDrawer(props: Props) {
  const { t } = useTranslation('experience');

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <SecondaryButton alignSelf="center" colorScheme="gray" onClick={onOpen}>
        { t('details.reviews.button', { count: props.reviews.length }) }
      </SecondaryButton>

      <Drawer isOpen={isOpen} onClose={onClose} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            { t('drawers.reviews.title') }
          </DrawerHeader>

          <DrawerBody w="100%" p={5}>
            <VStack spacing={5}>
              { props.reviews.map((review, i) => <ReviewCard key={i} {...review} />) }
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}